//* Vue
import type { ExtractPropTypes } from "vue";
//* 组件库
import type { UiTypes } from "various-ui";

export const ModulePropsOption = {
    id: { type: String, required: true },
    mode: { type: String, required: true },
} as const;

export type ModuleProps = ExtractPropTypes<typeof ModulePropsOption>;

export interface ModuleData {
    count: number;
    selectors: UiTypes.candidate[];
    checkboxs: { name: string; value: string; number: number }[];
    statistics: { name: string; number: number }[];
}

export interface ModuleReference {
    id: string;
    jif: number;
    year: string;
    name: string;
    journal: string;
    abstract: string;
}
